import React from "react";
import { Navigate } from "react-router-dom";
import { hasMerchantPermission } from "../api/merchantAuthApi";

export default function PermissionRoute({ permission, children }) {
  return hasMerchantPermission(permission) ? children : <Navigate to="/" replace />;
}
